// Openserve packages
export const openservePackages = [
  // FTTH Packages
  {
    ID: 2802762,
    Title: "OpenServe 200/100Mbps - OS FTTH By Wondernet",
    Price: 1089.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 102400,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 2802764,
    Title: "OpenServe 300/150Mbps - OS FTTH By Wondernet",
    Price: 1243.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 153600,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 3977374,
    Title: "OpenServe 100/50Mbps - OS FTTH By Wondernet",
    Price: 839.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 51200,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 4830123,
    Title: "OpenServe 50/25Mbps - OS FTTH By Wondernet",
    Price: 659.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 25600,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 6514880,
    Title: "OpenServe 500/250Mbps - OS FTTH By Wondernet",
    Price: 1439.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 256000,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559740,
    Title: "OpenServe 50/50Mbps - OS FTTH By Wondernet",
    Price: 749.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559767,
    Title: "OpenServe 100/100Mbps - OS FTTH By Wondernet",
    Price: 939.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559768,
    Title: "OpenServe 200/200Mbps - OS FTTH By Wondernet",
    Price: 1149.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  
  // FTTB Packages
  {
    ID: 22559851,
    Title: "Openserve Office Connect 50/50Mbps - OS FTTB By Wondernet",
    Price: 999.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559852,
    Title: "Openserve Office Connect 100/100Mbps - OS FTTB By Wondernet",
    Price: 1149.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559853,
    Title: "Openserve Office Connect 200/200Mbps - OS FTTB By Wondernet",
    Price: 1349.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559854,
    Title: "Openserve Office Connect 300/300Mbps - OS FTTB By Wondernet",
    Price: 1799.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 307200,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559855,
    Title: "Openserve Office Connect 500/500Mbps - OS FTTB By Wondernet",
    Price: 2399.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559879,
    Title: "OpenServe SMB FTTB 200/200Mbps - OS FTTB By Wondernet",
    Price: 1299.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559880,
    Title: "OpenServe SMB FTTB 50/50Mbps - OS FTTB By Wondernet",
    Price: 849.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559881,
    Title: "OpenServe SMB FTTB 100/100Mbps - OS FTTB By Wondernet",
    Price: 999.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559882,
    Title: "OpenServe SMB FTTB 300/150Mbps - OS FTTB By Wondernet",
    Price: 1499.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 153600,
    Supplier: "Openserve",
    ISP: "Wondernet"
  },
  {
    ID: 22559883,
    Title: "OpenServe SMB FTTB 500/250Mbps - OS FTTB By Wondernet",
    Price: 1799.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 256000,
    Supplier: "Openserve",
    ISP: "Wondernet"
  }
];